import { useMutation, type MutationHookOptions } from "@apollo/client"
import tenantUserRemoveManyMutation from "@/v2-backoffice-client/tenant/user/remove/many/tenant.user.remove.many.mutation.gql"
import type {
  TenantUserRemoveManyMutation,
  TenantUserRemoveManyMutationVariables,
} from "@/v2-backoffice-client/tenant/user/remove/many/__types__/tenant.user.remove.many.mutation"

type RemoveOptions = MutationHookOptions<
  TenantUserRemoveManyMutation,
  TenantUserRemoveManyMutationVariables
>

export function useTenantUserRemoveManyMutation(options?: RemoveOptions) {
  return useMutation<
    TenantUserRemoveManyMutation,
    TenantUserRemoveManyMutationVariables
  >(tenantUserRemoveManyMutation, options)
}
